import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { Loader, SnackbarProvider } from 'fronton-react';
import { getRegionId, getShowStorefrontPics } from 'features/page-model/ducks/get-model';
import { MapSingleStore } from 'features/map-single-store';
import { getStoreDetail, getImageLink, getIsPickupPoint } from 'features/store/ducks/get-store-by-id';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { AddressCopySnack } from 'features/store-common-info/store-adress';
import { MainInfo } from './main-info';
import { StoreRoutes } from './store-routes';
import { AdditionalLinks } from './additional-links';
import { StoreContacts } from './store-contacts';
import { StoreServicesMain } from './store-services-main';
import { StoreVacancies } from './store-vacancies';
import { mapContainer, StoreInfoContainer, pickupPoint, loaderStyle } from './styles';
import { StoreFrontImage } from './store-front-image';

export const DATA_QA_STORE_COMMON_INFO = 'store-common-info';

export const StoreCommonInfo: FC = () => {
  const { smMobile, mobile } = useBreakpoints() ?? {};
  const regionId = useSelector(getRegionId);
  const imageLink = useSelector(getImageLink);
  const showStoreFrontImage = !!useSelector(getShowStorefrontPics);
  const { geocoordinateLongitude, geocoordinateLatitude } = useSelector(getStoreDetail) || {};
  const [mapLoaded, setMapLoaded] = useState(false);
  const shouldShow = geocoordinateLatitude && geocoordinateLongitude && !mobile && !smMobile;
  const isPickupPoint = useSelector(getIsPickupPoint);

  return (
    <SnackbarProvider>
      <section id="store-info" data-qa={DATA_QA_STORE_COMMON_INFO}>
        <StoreInfoContainer className={isPickupPoint ? pickupPoint : undefined}>
          <MainInfo />
          {shouldShow && (
            <div className={mapContainer}>
              {!mapLoaded && <Loader size="m" className={loaderStyle} />}
              <MapSingleStore
                setMapLoaded={setMapLoaded}
                activeRegionId={regionId}
                latitude={geocoordinateLatitude}
                longitude={geocoordinateLongitude}
              />
              {imageLink && mapLoaded && showStoreFrontImage && <StoreFrontImage imageUrl={imageLink} />}
            </div>
          )}
          <StoreRoutes />
          {!isPickupPoint && <AdditionalLinks />}
          <StoreContacts />
          {!isPickupPoint && <StoreServicesMain />}
          <StoreVacancies />
        </StoreInfoContainer>
      </section>
      <AddressCopySnack />
    </SnackbarProvider>
  );
};
